module.exports = __webpack_public_path__ + "static/media/ggmap.a3e01e20.png";